import React from "react";
import SalesList from "./SalesList";

// Admin "Sales" page — interactive list of Digital Ghanti sales with an
// Add Sale flow. Data is local for now; swap the Services stubs for the real
// backend endpoints once available.
function Sales() {
    return <SalesList/>;
}

export default Sales;
